import React, { Component } from "react";
import { Select, Spin, Button, notification } from "antd";
import { Formik } from "formik";
import { connect } from "react-redux";
import { deleteInventory } from "../../Graphs/Card/deleteInventory";
import { searchCard } from "../../Graphs/Card/searchCard";
import Title from "./Title";
import { DollarSign } from "react-feather";
import InventoryDownloadTable from "./InventoryDownloadTable";
import { getDeletedBatches } from "../../Graphs/Card/getDeletedBatchesList";
import { getDeletedBatchInventory } from "../../Graphs/Card/getDeletedBatchInventory";
import { alertError } from "../../utils/alert";
var moment = require("moment");
const { Option } = Select;
const PAGE_SIZE = 20;

function debounce(fn, wait) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CardSelect extends Component {
  state = {
    options: [],
    search: "",
    page: 1,
    loading: false,
    hasMore: true,
  };

  constructor(props) {
    super(props);
    this.doSearchDebounced = debounce(this.doSearch.bind(this), 300);
  }

  componentDidMount() {
    this.loadPage(1, "", true);
  }

  loadPage = async (page, search, reset = false) => {
    if (this.state.loading) return;
    this.setState({ loading: true });

    try {
      const { authToken, loginUserData } = this.props;

      const city =
        loginUserData?.role === "Sub_admin" ? loginUserData?.city : "";

      const response = await searchCard(
        authToken,
        search,
        (page - 1) * PAGE_SIZE,
        PAGE_SIZE,
        city
      );

      if (response?.status === 200) {
        let filtered = response.data;
        const mapped = filtered.map((card) => ({
          label: card.name,
          value: card.id,
        }));

        this.setState((prev) => ({
          options: reset ? mapped : [...prev.options, ...mapped],
          loading: false,
          page,
          hasMore: mapped.length === PAGE_SIZE,
        }));
      } else {
        this.setState({ loading: false });
      }
    } catch (err) {
      this.setState({ loading: false });
    }
  };

  doSearch(search) {
    this.setState({ search, page: 1, hasMore: true });
    this.loadPage(1, search, true);
  }

  handleSearch = (val) => {
    this.doSearchDebounced(val);
  };

  handlePopupScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const { loading, hasMore, page, search } = this.state;

    if (scrollTop + clientHeight >= scrollHeight - 10 && !loading && hasMore) {
      this.loadPage(page + 1, search, false);
    }
  };

  renderOption = (opt) => (
    <Option key={opt.value} value={opt.value}>
      {opt.label}
    </Option>
  );

  render() {
    const { options, loading } = this.state;

    return (
      <Select
        className="custom-select-download-inventory"
        showSearch
        style={{ width: 350 }}
        value={this.props.value || undefined}
        placeholder="Search card..."
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={(val) => this.props.onChange(val)}
        onPopupScroll={this.handlePopupScroll}
        notFoundContent={loading ? <Spin size="small" /> : "No data"}
        optionLabelProp="children"
      >
        {options.map(this.renderOption)}

        {loading && (
          <Option key="loading" disabled>
            <div style={{ textAlign: "center" }}>
              <Spin size="small" />
            </div>
          </Option>
        )}
      </Select>
    );
  }
}

class DownloadInventory extends Component {
  state = {
    initialValues: {
      card: "",
      quantity: "",
    },
    tableData: [],
    totalRecords: 0,
  };

  componentDidMount() {
    this.loadTable();
  }

  loadTable = async (start = 0, end = 20) => {
    try {
      const { authToken, loginUserData, history } = this.props;
      const city =
        loginUserData?.role === "Sub_admin" ? loginUserData?.city : "";

      const res = await getDeletedBatches(authToken, start, end, city);

      if (res?.status === 200) {
        this.setState({ tableData: res.data });
        this.setState({ totalRecords: res.total });
      } else if (res?.status === 400) {
        notification["error"]({
          message: res?.message,
        });
      } else if (res?.status === 401) {
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (error) {
      console.error("Fetch table error:", error);
    }
  };

  validateForm = (values) => {
    let errors = {};

    if (!values.card) {
      errors.card = "Required";
    }

    if (!values.quantity) {
      errors.quantity = "Required";
    } else if (!/^\d+$/.test(values.quantity)) {
      errors.quantity = "Must be a number";
    }

    return errors;
  };
  generateCsv = async (id) => {
    try {
      this.setState({ isLoading: true });

      const { authToken, loginUserData } = this.props;

      let city = loginUserData.role === "Sub_admin" ? loginUserData.city : "";

      const response = await getDeletedBatchInventory(authToken, id, city);

      if (
        response.status !== 200 ||
        !response.data ||
        response.data.length === 0
      ) {
        this.setState({ isLoading: false });
        return;
      }

      const allData = response.data;

      const escapeCsv = (value) => {
        if (value === null || value === undefined) return "";
        const str = String(value);
        return `"${str.replace(/"/g, '""')}"`;
      };

      const rows = [];

      rows.push([
        "Sr.No.",
        "Card Name",
        "User Name",
        "Serial Number",
        "Redeem Code",
        "Added By",
        "Paid",
        "Order Code",
        "Reference Id",
      ]);

      allData.forEach((item, idx) => {
        const cardName = item.card?.name || "-";
        const userName = item.user?.first_name || "-";
        const serialNumber = item.serial_number || "-";
        const redeemCode = item.redeem_code || "-";

        const addedByRaw = item.added_by || "-";
        const addedBy =
          redeemCode && addedByRaw === "sub_admin" ? "Sub Admin" : addedByRaw;

        const paid = item.is_paid ? "PAID" : "UNPAID";

        let orderCode = "-";
        let referenceId = "-";

        if (item.is_paid) {
          if (item.user_transaction) {
            orderCode = item.user_transaction.order_code || "-";
            referenceId = item.user_transaction.reference_id || "-";
          } else if (item.user_wallet_transaction) {
            orderCode = item.user_wallet_transaction.order_code || "-";
            referenceId = item.user_wallet_transaction.reference_id || "-";
          }
        }

        rows.push([
          idx + 1,
          cardName,
          userName,
          serialNumber,
          redeemCode,
          addedBy,
          paid,
          orderCode,
          referenceId,
        ]);
      });

      // 4️⃣ Convert to CSV string
      const csvContent = rows
        .map((row) => row.map((cell) => escapeCsv(cell)).join(","))
        .join("\r\n");

      // 5️⃣ Download CSV using Blob
      const csvName = `redeem_codes_${moment().format("YYYYMMDD_HHmmss")}.csv`;

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = csvName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      alertError("REDEEM", e);
    } finally {
      this.setState({ isLoading: false });
    }
  };
  handleSubmit = async (values, { resetForm }) => {
    try {
      const { authToken, loginUserData, history } = this.props;

      const city =
        loginUserData?.role === "Sub_admin" ? loginUserData?.city : "";

      const card_id = values.card;
      const count = values.quantity;

      const data = await deleteInventory(authToken, card_id, count, city);

      if (data?.status === 200) {
        resetForm();
        this.loadTable();
        notification["success"]({
          message: data?.message,
        });
        this.generateCsv(data?.data?.deleted_batch_id);
      } else if (data?.status === 400) {
        notification["error"]({
          message: data?.message,
        });
      } else if (data?.status === 401) {
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (error) {
      console.error("Delete API Error:", error);
    }
  };

  render() {
    return (
      <>
        <Title
          parent="download-inventory"
          title="Download Request"
          icon={<DollarSign />}
          url="/download-inventory"
        />

        <div className="container-fluid ">
          <Formik
            initialValues={this.state.initialValues}
            validate={this.validateForm}
            onSubmit={this.handleSubmit}
          >
            {(formik) => (
              <div className="cardDownload">
                <div>
                  <label
                    className="col-form-label d-block"
                    style={{ color: "black" }}
                  >
                    Select Card
                  </label>
                  <CardSelect
                    value={formik.values.card}
                    onChange={(v) => formik.setFieldValue("card", v)}
                    authToken={this.props.authToken}
                    loginUserData={this.props.loginUserData}
                  />
                  {formik.errors.card && (
                    <div style={{ color: "red", marginTop: 4 }}>
                      {formik.errors.card}
                    </div>
                  )}
                </div>

                <div>
                  <label
                    className="col-form-label d-block"
                    style={{ color: "black" }}
                  >
                    Quantity
                  </label>
                  <input
                    type="text"
                    name="quantity"
                    placeholder="Enter quantity"
                    value={formik.values.quantity}
                    onChange={formik.handleChange}
                    style={{
                      padding: 6,
                      border: "1px solid #ccc",
                    }}
                  />
                  {formik.errors.quantity && (
                    <div style={{ color: "red", marginTop: 4 }}>
                      {formik.errors.quantity}
                    </div>
                  )}
                </div>

                <div>
                  <Button
                    htmlType="submit"
                    type="primary"
                    onClick={formik.handleSubmit}
                  >
                    Download
                  </Button>
                </div>
              </div>
            )}
          </Formik>

          <InventoryDownloadTable
            data={this.state.tableData}
            totalRecords={this.state.totalRecords}
            loadTable={this.loadTable}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

export default connect(mapStateToProps)(DownloadInventory);
